"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelFieldNestedList = exports.ModelMutatorNestedList = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var collection_field_1 = require("../collection.field");
var ModelMutatorNestedList = /** @class */ (function (_super) {
    tslib_1.__extends(ModelMutatorNestedList, _super);
    function ModelMutatorNestedList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModelMutatorNestedList.prototype.manual = function (newText) {
        if (newText == null || !Array.isArray(newText)) {
            this.state.setFieldValue(this.field.id, null);
            return;
        }
        var options = this.field.schema.findOptions(newText);
        if (options == null || options.length !== newText.length || options.length === 0) {
            this.state.setFieldValue(this.field.id, null);
            return;
        }
        this.state.setFieldValue(this.field.id, newText);
    };
    ModelMutatorNestedList.prototype.copy = function (from) {
        if (!from.hasValue()) {
            this.manual(null);
            return true;
        }
        var value = from.value;
        if (this.field.schema.findOptions(value) != null) {
            this.manual(value);
            return true;
        }
        return false;
    };
    //Copies values from another Nested List, but only those that exist in the current field's schema.
    ModelMutatorNestedList.prototype.truncatedCopy = function (from) {
        var _this = this;
        if (!from.hasValue()) {
            this.manual(null);
            return true;
        }
        var validValues = from.value.filter(function (v) {
            var found = _this.field.schema.findOptions([v]);
            return found && found.length === 1;
        });
        if (validValues.length > 0) {
            this.manual(validValues);
            return true;
        }
        return false;
    };
    return ModelMutatorNestedList;
}(collection_field_1.ModelMutator));
exports.ModelMutatorNestedList = ModelMutatorNestedList;
var CollectionModelFieldNestedList = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelFieldNestedList, _super);
    function CollectionModelFieldNestedList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CollectionModelFieldNestedList.isNestedListField = function (f) {
        return f.schema.type === CollectionModelFieldNestedList.TYPE;
    };
    CollectionModelFieldNestedList.parse = function (text) {
        if (typeof text !== 'string') {
            return null;
        }
        return text.split(' > ');
    };
    Object.defineProperty(CollectionModelFieldNestedList.prototype, "Mutator", {
        get: function () {
            if (this._Mutator == null) {
                this._Mutator = new ModelMutatorNestedList(this);
            }
            return this._Mutator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldNestedList.prototype, "value", {
        get: function () {
            return this.stateValue || [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldNestedList.prototype, "displayValue", {
        get: function () {
            return this.value.join(' > ');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldNestedList.prototype, "color", {
        get: function () {
            for (var _i = 0, _a = this.schema.options.values; _i < _a.length; _i++) {
                var option = _a[_i];
                if (option.value === this.value[0]) {
                    return option.color;
                }
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelFieldNestedList.prototype.hasValue = function () {
        return this.value.length > 0;
    };
    CollectionModelFieldNestedList.TYPE = core_api_1.IkeFieldType.NESTED_LIST;
    return CollectionModelFieldNestedList;
}(collection_field_1.CollectionModelField));
exports.CollectionModelFieldNestedList = CollectionModelFieldNestedList;
//# sourceMappingURL=nested.list.field.js.map